import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import arrayMove from 'array-move';
import { get } from 'lodash';
import React from 'react';
import { Input, OriCheckbox, OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import { DeleteIcon } from 'src/components/Icon';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ResponsiveAnimation,
  ResponsiveTabStyle,
  ResponsiveText,
} from 'src/components/Modules/Components';
import ModuleStyle from 'src/components/Modules/Components/ModuleStyle';
import Switcher from 'src/components/SectionSwitcher';
import {
  errKeys,
  generateTabProduct,
} from 'src/constrains/DraggableModules/tools';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import {
  EModuleWidth,
  EOverflowOption,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveProductToShow,
} from 'src/types/common/module';
import css from './css.module.less';

const Option = OriSelect.Option;

const ResponsiveProductTab = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    tabs,
    onItemAdd,
    onItemDelete,
    onItemChange,
    //onItemReselect,
    onItemSort,
    onStaticChange,
    specificError,
    staticData,
    breakpoint,
    animations,
    hoverAnimations,
    buttons,
  } = props;
  const isConvertible = breakpoint && breakpoint !== EPreviewSize.WIDE;
  const isMobile = breakpoint && breakpoint === EPreviewSize.MOBILE;
  const onlyLastTab = (tabs || []).length === 1;
  const draggableId = get(staticData, 'draggableId');
  //const posterType = get(staticData, 'posterType');
  const moduleWidth = get(staticData, 'moduleWidth');
  const leaveGap = get(staticData, 'leaveGap');
  const text = get(staticData, 'moduleText');
  const moduleStyle = get(staticData, 'moduleStyle');
  const animation = get(staticData, 'animation');
  const tabStyle = get(staticData, 'tabStyle');
  const overflowOption = get(staticData, 'overflowOption');

  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;
  const selectedTab = get(staticData, 'selectedTab');

  const shouldHideModuleBkgSetting =
    moduleWidth === EModuleWidth.NONE || moduleWidth === EModuleWidth.FULL;

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnLeaveGapChange = (e) => {
    const leaveGap = e.target.checked;
    onStaticChange({ leaveGap });
  };

  const handleOnOverflowOptionChange = (overflowOption) => {
    onStaticChange({ overflowOption });
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleTextChange = (ani) => {
    const newText = { ...(text || {}), ...ani };
    onStaticChange({ moduleText: newText });
  };

  const handleTabStyleChange = (tab) => {
    const newTabStyle = { ...(tabStyle || {}), ...tab };
    onStaticChange({ tabStyle: newTabStyle });
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onItemSort(oldIndex, newIndex);
  };

  const handleOnTabChange = (index, data) => {
    onItemChange(index, data);
  };

  const handleOnItemDelete = (index, draggableId) => {
    //selectedTab

    if (draggableId === selectedTab) {
      const newTabs = tabs.filter((i) => i.draggableId !== draggableId);

      if (newTabs.length > 0) {
        const newId = get(newTabs, '0.draggableId');

        onStaticChange({ selectedTab: newId });
      }
    }
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const handleOnItemAdd = () => {
    const data = generateTabProduct((tabs || []).length + 1);
    onItemAdd([data]);
    //
    if (!selectedTab) {
      const { draggableId } = data;
      onStaticChange({ selectedTab: draggableId });
    }
    //selectedTab
  };

  const handleOnPosterTabChange = (selectedTab) => {
    onStaticChange({ selectedTab });
  };

  //const handleOnPosterNameChange = () => {};

  // const hideGapLarge =
  //   isMobile || (isTablet && posterType === EResponsivePosterType.SIX);
  const childGenerate = (data, index) => {
    const { title, draggableId } = data;
    const nameErrK = errKeys.ResponsiveProductTab.tabName;
    const nameErr = specificError[`${draggableId}${nameErrK}`] || [];
    return (
      <div className={css.tabContainer}>
        <ItemWrapper
          size='small'
          titleClassName={css.titleContainer}
          title={
            <div className={css.titleTitleContainer}>
              {getI18n('general.tabTitle')}
              {!onlyLastTab && (
                <DeleteIcon
                  onDelete={() => {
                    // console.log('delete');
                    handleOnItemDelete(index, draggableId);
                  }}
                  //iconClassName={css.deleteIcon}
                />
              )}
            </div>
          }>
          <Input
            error={nameErr.length > 0}
            help={nameErr.join('')}
            size='large'
            maxLength={100}
            value={title}
            onChange={(title) => {
              onItemChange(index, { title });
            }}
          />
        </ItemWrapper>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Section size='small' bottomBorder>
        {!isConvertible && (
          <ItemWrapper title={getI18n('general.moduleWidth')}>
            <OriSelect
              size='large'
              value={moduleWidth}
              onChange={handleOnModuleWidthChange}>
              <Option value={EModuleWidth.WIDE}>
                {getI18n('general.wideWidth')}
              </Option>
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            </OriSelect>
          </ItemWrapper>
        )}

        <React.Fragment>
          <div className={css.gapContainer}>
            <OriCheckbox checked={leaveGap} onChange={handleOnLeaveGapChange}>
              Leave gap between products
            </OriCheckbox>
          </div>
        </React.Fragment>
      </Section>
      {isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper title='Overflow Items Display Option'>
            <OriSelect
              size='large'
              value={overflowOption}
              onChange={handleOnOverflowOptionChange}>
              <OriSelect.Option value={EOverflowOption.AnotherLine}>
                Shift To Another Line
              </OriSelect.Option>
              <OriSelect.Option value={EOverflowOption.Hide}>
                Hide
              </OriSelect.Option>
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}
      <Section size='small' className={css.switcherContainer} bottomBorder>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ModuleStyle
                    hideBkgConfig={shouldHideModuleBkgSetting}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                    isMobileOrTablet={isConvertible}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Text]: {
                    title: getI18n('general.text'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveText
                          data={text}
                          onChange={handleTextChange}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                }),

            [EResponsiveCarouselModuleSwitcherType.TabStyle]: {
              title: getI18n('general.tabStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ResponsiveTabStyle
                    isConvertible={isConvertible}
                    data={tabStyle}
                    onChange={handleTabStyleChange}
                  />
                </div>
              ),
            },
            //
          }}
        />
      </Section>
      {!isConvertible && (
        <DragNDropColumns
          // disabled={!isPrimary}
          // hideAdd={!isPrimary}
          // hideTitle
          titleRightTextClassName={css.tabAddText}
          title='All Tabs'
          childGenerate={childGenerate}
          data={tabs || []}
          droppableId={`salesChannelContentListPosterTab${draggableId}`}
          onSort={handleItemOnSort}
          hideAdd={true}
          titleRightText={'+ Add Tab'}
          titleRightFunction={handleOnItemAdd}
        />
      )}

      {tabs && tabs.length > 0 && (
        <Section size='small' className={css.switcherContainer}>
          <Switcher
            selectContainer={css.switcher}
            selected={selectedTab}
            onChange={handleOnPosterTabChange}
            allSections={tabs.reduce((pre, now, index) => {
              const { draggableId: dId, title } = now;
              const amountErr =
                specificError[
                  `${dId}${errKeys.ResponsiveProductTab.productAmount}`
                ] || [];
              return {
                ...pre,
                [dId]: {
                  title: title,
                  hasError: amountErr.length > 0,
                  child: (
                    <ProductTab
                      buttons={buttons}
                      isMobile={isMobile}
                      isConvertible={isConvertible}
                      draggableId={dId}
                      specificError={specificError}
                      data={now}
                      onChange={(data) => {
                        handleOnTabChange(index, data);
                      }}
                    />
                  ),
                },
              };
            }, {})}
          />
        </Section>
      )}
    </React.Fragment>
  );
};

export default ResponsiveProductTab;

// const Animation = (props) => {
//   const { data, onChange, animations } = props;
//   const _animations = [
//     { value: null, label: 'None' },
//     ...(animations || []).map((i) => {
//       const { name, uuid } = i;
//       return { label: name, value: uuid };
//     }),
//   ];
//   const entranceUuid = get(data, 'entranceUuid') || null;
//   const hoverEffectUuid = get(data, 'hoverEffectUuid') || null;
//   return (
//     <React.Fragment>
//       <ItemWrapper size='small' title='Entrance Animation'>
//         <OriSelect
//           size='large'
//           value={entranceUuid}
//           onChange={(entranceUuid) => {
//             onChange({ entranceUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//       <ItemWrapper size='small' title='Hover Effect'>
//         <OriSelect
//           size='large'
//           value={hoverEffectUuid}
//           onChange={(hoverEffectUuid) => {
//             onChange({ hoverEffectUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//     </React.Fragment>
//   );
// };

const ProductTab = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = React.useState(false);
  const {
    onChange,
    data,
    draggableId,
    specificError,
    isMobile,
    isConvertible,
    buttons,
  } = props;
  const amountErr =
    specificError[
      `${draggableId}${errKeys.ResponsiveProductTab.productAmount}`
    ] || [];

  const { productToShow, products, buttonThemeUuid } = data;
  const handleOnButtonThemeChange = (buttonThemeUuid) => {
    onChange({ buttonThemeUuid });
  };
  const handleOnProductTypeChange = (productToShow) => {
    onChange({ productToShow });
  };
  const renderProductType = () => {
    return [
      <Option
        value={EResponsiveProductToShow.One}
        key={EResponsiveProductToShow.One}>
        {getI18n('general.oneProductOnScreen')}
      </Option>,

      <Option
        value={EResponsiveProductToShow.TwoPortrait}
        key={EResponsiveProductToShow.TwoPortrait}>
        {getI18n('general.twoProductsOnScreen')} ({getI18n('general.portrait')})
      </Option>,

      ...(isMobile
        ? []
        : [
            <Option
              value={EResponsiveProductToShow.TwoLandscape}
              key={EResponsiveProductToShow.TwoLandscape}>
              {getI18n('general.twoProductsOnScreen')} (
              {getI18n('general.landscape')})
            </Option>,
          ]),
      <Option
        value={EResponsiveProductToShow.Three}
        key={EResponsiveProductToShow.Three}>
        {getI18n('general.threeProductsOnScreen')}
      </Option>,
      ...(isConvertible
        ? []
        : [
            <Option
              value={EResponsiveProductToShow.Four}
              key={EResponsiveProductToShow.Four}>
              {getI18n('general.fourProductsOnScreen')}
            </Option>,
            <Option
              value={EResponsiveProductToShow.Five}
              key={EResponsiveProductToShow.Five}>
              {getI18n('general.fiveProductsOnScreen')}
            </Option>,
            <Option
              value={EResponsiveProductToShow.Six}
              key={EResponsiveProductToShow.Six}>
              {getI18n('general.sixProductsOnScreen')}
            </Option>,
          ]),
    ];
  };

  const childGenerate = (data, index) => {
    const sku = get(data, 'sku');
    const name = get(data, 'productName');
    const thumbnailUrl = get(data, 'thumbnailUrl');
    return <ProductDisplayInRow sku={sku} name={name} img={thumbnailUrl} />;
  };

  const handleOnItemDelete = (index) => {
    const _product = [...(products || [])];
    _product.splice(index, 1);
    onChange({ products: _product });
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    const _product = arrayMove(products, oldIndex, newIndex);
    onChange({ products: _product });
  };

  const handleOnProductsReselect = (products) => {
    const _product = products.map((i) => {
      const { uuid } = i;
      return { ...i, draggableId: uuid };
    });
    onChange({ products: _product });
  };

  return (
    <React.Fragment>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={() => {
            setVisible(false);
          }}
          onOk={handleOnProductsReselect}
          selectedProducts={products || []}
          disabledProducts={[]}
        />
      )}
      <Section size='small' bottomBorder className={css.posterContainer}>
        <ItemWrapper title={getI18n('general.productInARow')}>
          <OriSelect
            value={productToShow}
            size='large'
            onChange={handleOnProductTypeChange}>
            {renderProductType()}
          </OriSelect>
        </ItemWrapper>
        <ItemWrapper title={getI18n('general.callToActionButtonTheme')}>
          <OriSelect
            value={buttonThemeUuid}
            size='large'
            onChange={handleOnButtonThemeChange}>
            <Option value={null}>{getI18n('general.status.none')}</Option>
            {(buttons || []).map((i: any) => {
              return (
                <Option value={i.uuid} key={i.uuid}>
                  {i.name}
                </Option>
              );
            })}
          </OriSelect>
        </ItemWrapper>
      </Section>
      {amountErr.length > 0 && (
        <Section size='small' bottomBorder>
          <div className={css.errorContainer}>{amountErr.join('')}</div>
        </Section>
      )}
      {!isConvertible && (
        <DragNDropColumns
          hideTitle
          childGenerate={childGenerate}
          data={products || []}
          droppableId={`salesChannelContentListProductTab${draggableId}`}
          onSort={handleItemOnSort}
          onDelete={handleOnItemDelete}
          onAdd={() => {
            setVisible(true);
          }}
          addText={`+ ${getI18n('general.addProduct')}`}
        />
      )}
    </React.Fragment>
  );
};
